import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import '../../Croissance/Components/CroissanceFilters/CroissanceFilters.scss';
import _ from "../../../i18n";
import {
  STANDARIZATION_STATUS,
  TYPE_CLIENT_OPTIONS,
  AMOUNT_fACTURATION_OPTIONS,DELTA_VARIATION_OPTIONS
} from "../../../config";
import { useOnClickOutside, renderTeamYears, parsePreference } from "../../../utils";
import { TiArrowSortedDown } from "react-icons/ti";
import TTPFilterHorizontalBar from "../../common/Filter/TTPFilterHorizontalBar";
import { getPartners } from "../../../api/partners";
const StandarizationFilters = ({
  filter,
  nbResult,
  updateFilter,
  resetFilter,
  preferences,
}) => {
  const ref = useRef();
  useOnClickOutside(ref, () => setYearDivIsVisible(false));
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  const [partnerOptions, setPartnerOptions] = useState([]);

  const partnersQuery = useQuery(["partnersQuery", navCommunity], async () => {
    if (token) {
      try {
        const response = await getPartners({token, organizationId: navCommunity.id});
        let data = response.data.data.map(partner => (
          {
            value: partner.id,
            label: partner.name,
            zone: partner.zone
          }
        ))
        setPartnerOptions(data);
      } catch (e) {
        setPartnerOptions([]);
        return null;
      }
    }
  });

  const renderYearSelect = () => {
    return (
      <div
        ref={ref}
        className={
          "customed_select" +
          " " +
          (yearDivIsVisible ? "customed_select_opened" : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff",
        }}
      >
        <div
          className={"customed_select_header"}
          onClick={() => setYearDivIsVisible(!yearDivIsVisible)}
        >
          <span>{filter.year}</span>
          <div className={"actions"}>
            <div>
              <span className={"action"}>
                <TiArrowSortedDown />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={"customed_select_body"}>
            <div className={"customed_select_body_options"}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={"customed_select_body_option"}
                  onClick={() => updateFilter({ ...filter, year: item })}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleStatusChange = (item) => {
    updateFilter({ ...filter, globalStatus: item });
  };

  const handlePartnerChange = (item) => {
    updateFilter({ ...filter,   partner: item === null || item === "" ? null : Number(item)});
  };
  const handleTypeClientChange = (items) => {
    updateFilter({ ...filter, typeClient: items });
  };
  const handleBillingRangeChange = (items) => {
    updateFilter({ ...filter, billingRange: items });
  };
  const handleDeltaVariationRangeChange = (items) => {
    updateFilter({ ...filter, deltaVariationRange: items });
  };

  let filters = [
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("status"),
        options: STANDARIZATION_STATUS,
        action: handleStatusChange,
        values:  filter.globalStatus,
      },
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("clientType"),
        options: TYPE_CLIENT_OPTIONS,
        action: handleTypeClientChange,
        values:  filter.typeClient,
      },
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("montant de facutration"),
        options: AMOUNT_fACTURATION_OPTIONS,
        action: handleBillingRangeChange,
        values:  filter.billingRange,
      },
    },
    {
      grid: 3,
      type: "SELECT",
      options: {
        isSimple: true,
        isClearable: true,
        placeholder: _("delta de variation"),
        options: DELTA_VARIATION_OPTIONS,
        action: handleDeltaVariationRangeChange,
        values:  filter.deltaVariationRange,
      },
    },
  ];

  if ([1, 11].includes(parsePreference(preferences.financial).croissance.allowViewDataBy)) {
      filters.unshift({
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          isDisabled:
          parsePreference(preferences.financial).croissance.allowViewDataBy === 101,
          placeholder: _("Partner"),
          options: partnerOptions,
          values: filter.partner,
          action: handlePartnerChange
        },
      });
    }
  let countFilter = 0;
  filters.forEach((filter) => {
    if (filter && filter.options.values && filter.options.values.length > 0) {
      countFilter++;
    }
  });

  return (
    <div className="croissance_filters_container">
      <TTPFilterHorizontalBar
        button
        bg="#FFF"
        subBG="F8F9FA"
        searchBox
        filter={filter}
        filters={filters}
        nbResult={nbResult}
        countFilter={countFilter}
        pageSize={filter.pageSize}
        customAddOn={renderYearSelect()}
        updateFilterContent={updateFilter}
        resetFilterContent={resetFilter}
        cssClass="croissance_filters"
      />
    </div>
  );
};

export default StandarizationFilters;
